import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { categoryIcons } from "../DataEstate/DataEstateDrives";
import "./DataTagCategoryFilters.scss";

const categoryNames = {
  PERSONAL: "Personal",
  MARKETING: "Marketing",
  FINANCIAL: "Financial",
  ORGANIZATIONAL: "Organizational",
  MEDICAL: "Medical",
  API: "API",
  NO_SENSITIVITY: "No Sensitivity",
  OTHER: "Other",
  NOT_PROCESSED: "Not Processed",
};

// categories that should not appear as filter icons
const HIDDEN_CATEGORIES = ["NOT_PROCESSED"];

function DataTagCategoryFilters({ value = [], onChange, loc }) {
  const summaryDataRaw = useSelector(
    (state) => state.dataTagReducer.categoryCardData
  );
  const [selected, setSelected] = useState(value || []);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const toggleSelection = (key) => {
    const newSelected = selected.includes(key)
      ? selected.filter((x) => x !== key)
      : [...selected, key];
    setSelected(newSelected);
    onChange?.(newSelected);
  };

  const items = (summaryDataRaw || []).filter(
    (fil) => !HIDDEN_CATEGORIES.includes(fil["DataTagSensitivity.finalType"])
  );

  return (
    <div className="DataTagCategoryFiltersContainer">
      {items.map((fil) => {
        const type = fil["DataTagSensitivity.finalType"];
        const isActive = selected.includes(type);
        return (
          <div
            key={type}
            className="DataTagCategoryFilters"
            onClick={() => toggleSelection(type)}
          >
            {/* name only on hover - no counts next to the icons */}
            <div title={categoryNames[type] || type}>
              <img
                className={
                  isActive
                    ? "data-tag-category-img isActive"
                    : "data-tag-category-img"
                }
                src={categoryIcons[type]}
                alt={categoryNames[type] || type}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DataTagCategoryFilters;